<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
          <div class="breadcrumbs__list">
              <router-link to="/" class="breadcrumbs__item">Home</router-link>
              <div class="breadcrumbs__item breadcrumbs__item--active">News</div>
          </div>
      </div>
    </div>
      <a id="home" name="home"></a>
    <div class="news">
        <div class="container">
            <div class="news__body">
                <main class="news__content">
                    <div class="news__list">
                        <div class="news__list__body">
                            <a v-bind:href="'/news/' + item.slug" class="news-item" v-for="item in news" :key="item.slug">
                                <div class="news-item__preview">
                                    <img v-bind:src="item.img" :alt="item.title.rendered" class="news-item__preview__img" />
                                </div>
                                <h3 class="news-item__title">{{ item.title.rendered }}</h3>
                                <p class="news-item__desc" v-html="item.excerpt.rendered"></p>
                            </a>
                        </div>
                        <div class="news__list__controls">
                            <a href="#" class="button button--rounded button--small button--primary-otln">load more</a>
                        </div>
                    </div>
                </main>
                <aside class="news__sidebar">
                    <div class="banner">
                        <h2 class="banner__title">EASY TO START</h2>
                        <h3 class="banner__sub-title">with AdOperator</h3>
                        <p class="banner__desc">Create an account at ADOP system and start your campaign with any budget!</p>

                        <div class="banner__controls">
                            <!--<a href="//client.adop.co/advertiser/signup" class="button button&#45;&#45;rounded button&#45;&#45;wshadow button&#45;&#45;secondary">create an account</a>-->
                            <router-link to="/signup" class="button button--rounded button--wshadow button--secondary">create an account</router-link>
                        </div>
                    </div>

                    <div class="subscribe-form">
                        <div class="subscribe-form__preview">
                            <img src="/static/img/mailbox.svg" alt="mailbox" class="subscribe-form__preview__img">
                        </div>

                        <h3 class="subscribe-form__title">Don't miss updates from us!</h3>
                        <p class="subscribe-form__desc">Subscribe for our newsletters. Be in touch with ADOP news</p>

                        <form class="subscribe-form__body" @submit.prevent="subscribe()">
                            <div class="subscribe-form__body__input">
                                <input type="email" v-model="email" class="input-default input-default--rounded input-default--small" placeholder="Enter your email address">
                            </div>
                            <div class="subscribe-form__body__controls">
                                <button class="button button--rounded button--primary">Subscribe</button>
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import wp from '@/utils/wp'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'News',
  data () {
    return {
      news: [],
      media: [],
      email: ''
    }
  },
  head: {
    title: {
      inner: 'News',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'News page Ad Operator'
      },
      {
        name: 'keywords',
        content: 'news'
      },
      {
        property: 'og:title',
        content: 'News - Ad Operator'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/news'
      },
      {
        property: 'og:description',
        content: 'News page Ad Operator'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co/news',
        id: 'canonical'
      }
    ]
  },
  methods: {
    subscribe: function () {
      console.log(this.email)
      axios.get('/api/optin?email=' + this.email)
        .then(resp => {
          Swal('Success', 'You subscribed', 'success')
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    window.$('html,body').scrollTop(window.$('#home').offset().top)
    wp({type: 'posts', data: {categories: 2}})
      .then(resp => {
        this.news = resp
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/front/news/list.vue